<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="innerValue"
              prepend-icon="mdi-calendar"
              v-on="on"
              :label="label"
              :readonly="$attrs.readonly"
              :error-messages="errors"
              autocomplete="off"
             
            ></v-text-field>
          </template>
            <v-date-picker
              ref="picker"
              v-model="month"
              no-title
              :locale="$i18n.locale"
              @click:month="saveMonth"
              :show-current="false"
              reactive
              class="rx-month"
            >
          </v-date-picker>
        </v-menu>
        {{ month}}
        {{innerValue}}
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: [Number, String],
    },
    label: String
  },
  data() {
    return {
      menu: false,
      innerValue: null,
      month: null
    }
  },
  methods: {
    saveMonth(month) {
        this.innerValue = new Date(`${month}`).toISOString().substr(5, 2);
        // activePicker to type YEAR
        setTimeout(() => (this.$refs.picker.activePicker = 'MONTH'));
        // Close the menu/datepicker
        this.menu = false;
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
        if(newVal.length >= 2) {
          this.month = new Date(new Date().getFullYear(), newVal).toISOString().substr(0, 10);
          this.$emit("input", newVal);
        }

    },
    // Handles external model changes.
    value(newVal) {
      if(newVal.length >= 2) {
        this.month = new Date(new Date().getFullYear(), newVal).toISOString().substr(0, 10);
        
        this.innerValue = newVal;
      }
    },
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'MONTH'));
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
<style>
  .rx-month .v-date-picker-header {
    display: none
  }
</style>
  